export default "__VITE_PUBLIC_ASSET__531a1d22__"